import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import { Select } from '@welcome-ui/select';
import { MdClose } from 'react-icons/md';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useNotification } from '../../context/notification';
import { icons } from '../../config';
import HtmlTemplates from './HtmlTemplates';
import useOnUpdate from '../../hooks/useOnUpdate';
import {
  editMessage,
  getTemplates
} from '../../api/ticker';

function MenuNewMessage(props) {
  const { setSideMenu, carousel, setNotifications, messageData, setPreview, setMessageData, languages } = props;
  const [options, setOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const { addNotification } = useNotification();

  const activeMode = languages.find(l => l.languageID === carousel.languageID).active;
  const counter = activeMode === "main" ? messageData?.counter_main : messageData?.counter_backup;

  const { isLoading } = useQuery('templates', getTemplates, {
    onSuccess: (data) => {
      setOptions(
        data
          .filter((template) => template.carouselID === carousel.carouselID && template.type !== 5)
          .map((template) => ({
            label: template.label?.toUpperCase(),
            value: template.htmlFile,
            templateID: template.templateID,
            type: template.type,
            icon: icons.filter((item) => item.templateLabel === template.label)[0]?.icon,
            color: icons.filter((item) => item.templateLabel === template.label)[0]?.color,
          })),
      );
      if (!messageData?.templateLabel) {
        setSelectedTemplate({
          filename: data.filter((template) => template.carouselID === carousel.carouselID)[0].htmlFile,
          templateID: data.filter((template) => template.carouselID === carousel.carouselID)[0].templateID,
          templateType: data.filter((template) => template.carouselID === carousel.carouselID)[0].type,
        });
      }
    },
  });

  useOnUpdate(() => {
    if (messageData.templateLabel && options.length > 0) {
      const defaultValue = options.filter((opt) => opt.label?.toLowerCase() === messageData.templateLabel.toLowerCase())[0];
      setSelectedTemplate({ filename: defaultValue.value, templateID: defaultValue.templateID, templateType: defaultValue.type });
    }
  }, [options]);


  function handleResetCounter() {    
    editMessage({
      ...messageData,
      position: messageData?.position || 0,
      carouselID: carousel.carouselID,
      isLive: messageData?.isLive || false,
      isVisible: messageData?.isVisible !== undefined ? messageData?.isVisible : true,
      counter: 0,
      isMain: activeMode === "main"
    }, messageData.messageID).then(() => {
      addNotification({ message: `Reset ok` });
      document.getElementById("counter-value").textContent="0";
    }).catch(() => {
      addNotification({ message: `Error`, severity: 'error' });
    })
  }

  return (
    <div className="details" id="detailForm">
      <div className="headerDetails flex items-center justify-between mb-4 p-2">
        <h2 className="w-fit pb-1 text-lg font-medium max-w-lg" title={messageData?.content}>
          {messageData?.content || 'Nouveau message'}
        </h2>
        <button
          type="button"
          className="w-fit justify-self-end"
          onClick={() => {
            setSideMenu(false);
            sessionStorage.removeItem('RUBRIQUE_1');
            sessionStorage.removeItem('RUBRIQUE_2')
          }}
        >
          <MdClose color="white" className="danger transition-all duration-300" size={20} />
        </button>
      </div>

      <div className="w-full p-4" style={{ position: "relative" }}>
        <div className="mb-4">
          <span>Template</span>
          {messageData?.createdDate ? (
            <div style={{ position: "absolute", right: "20px", top: "0", fontSize: "14px" }}>
              <span>
                Date de création
              </span>
              <br />
              <span>
                {new Date(messageData.createdDate).toLocaleString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                }).replace(',', '')}
              </span>
            </div>
          ) : null}

          {counter != null ? (
            <div className='counter-container' style={{ zIndex: "10000", display: "flex", position: "absolute", right: "20px", bottom: "30px", fontSize: "14px", textAlign: "right" }}>
              <div>
                <span>
                  Nb passages
                </span>
                <br />
                <span id="counter-value">
                  {counter}
                </span>
              </div>
              {/* <input type="submit" id="reset-counter" form='templateForm' value="Reset" /> */}
              <input type="button" onClick={() => handleResetCounter()} id="reset-counter" form='templateForm' value="Reset" />

            </div>
          ) : null}
          <Select
            name="selectTemplate"
            className="mt-2 max-w-md"
            placeholder="Select template..."
            options={isLoading ? [{ label: 'Chargement...', value: '', icon: CircularProgress }] : options}
            size="sm"
            id="test"
            value={selectedTemplate?.filename}
            onChange={(e, obj) => {
              setSelectedTemplate({
                filename: e,
                templateID: obj?.target?.value?.templateID,
                templateType: obj?.target?.value?.type,
              });
              console.log('select template onchange', messageData?.content, !messageData?.content, messageData);
              const rubrique1 = messageData.messageData?.find(x=> x.field === "RUBRIQUE_1");
              const rubrique2 = messageData.messageData?.find(x=> x.field === "RUBRIQUE_2");
              setMessageData({
                ...messageData,
                messageData:
                  [
                    {
                      field: "RUBRIQUE_1",
                      messageDataID: rubrique1?.messageDataID,
                      value: sessionStorage.getItem('RUBRIQUE_1')
                        ?? rubrique1?.value
                        ?? ''
                    },

                    {
                      field: "RUBRIQUE_2",
                      messageDataID: rubrique2?.messageDataID,
                      value: sessionStorage.getItem('RUBRIQUE_2')
                        ?? rubrique2?.value
                        ?? ''
                    },
                  ]
              });
            }}
            renderItem={(option) => {
              const Icon = option?.icon;
              return (
                <div className="flex items-center space-x-2">
                  {Icon && <Icon color={option.color} size={15} />} <span className=" text-md">{option.label}</span>
                </div>
              );
            }}
          />
          {carousel.type === 1 && selectedTemplate?.templateType === 1 && (
            <FormControlLabel
              control={
                <Checkbox
                  style={{ color: 'white' }}
                  onClick={(e) => {
                    if (e.target.checked) {
                      const templateUrgent = options.filter((opt) => opt.label === 'URGENT')[0];
                      const rubrique1 = messageData.messageData?.find(x=> x.field === "RUBRIQUE_1");
                      const rubrique2 = messageData.messageData?.find(x=> x.field === "RUBRIQUE_2");
                      setSelectedTemplate({
                        filename: templateUrgent.value,
                        templateID: templateUrgent.templateID,
                        templateType: templateUrgent.type,
                      });
                      setMessageData({
                        ...messageData,
                        messageData:
                        [
                          {
                            field: "RUBRIQUE_1",
                            messageDataID: rubrique1?.messageDataID,
                            value: sessionStorage.getItem('RUBRIQUE_1')
                              ?? rubrique1?.value
                              ?? ''
                          },

                          {
                            field: "RUBRIQUE_2",
                            messageDataID: rubrique2?.messageDataID,
                            value: sessionStorage.getItem('RUBRIQUE_2')
                              ?? rubrique2?.value
                              ?? ''
                          },
                        ]
                      });
                    } else {
                      const templateNormal = options.filter((opt) => opt.label === 'NORMAL')[0];
                      setSelectedTemplate({
                        filename: templateNormal.value,
                        templateID: templateNormal.templateID,
                        templateType: templateNormal.type,
                      });
                    }
                  }}
                />
              }
              label="Message urgent"
            />
          )}
        </div>
        <Divider textAlign="left">Message</Divider>
        { }
        {
          selectedTemplate?.filename && (
            <HtmlTemplates
              setPreview={setPreview}
              setNotifications={setNotifications}
              carousel={carousel}
              setSideMenu={setSideMenu}
              filename={selectedTemplate.filename}
              templateID={selectedTemplate.templateID}
              templateType={selectedTemplate.templateType}
              messageData={messageData}
            />
          )
        }
      </div >
    </div >
  );
}

MenuNewMessage.propTypes = {
  setSideMenu: PropTypes.func,
  setPreview: PropTypes.func,
  carousel: PropTypes.object,
  setNotifications: PropTypes.func,
  messageData: PropTypes.object,
  setMessageData: PropTypes.func,
  languages: PropTypes.array
};
MenuNewMessage.defaultProps = {
  setSideMenu: () => { },
  setPreview: () => { },
  setNotifications: () => { },
  carousel: {},
  messageData: {},
  setMessageData: () => { },
  languages: []
};

export default MenuNewMessage;
